/* Copyright Verge Technologies 2018
 * @file panel.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component responsible for housing panels for products
 */

// Modules
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import DescriptionPanel from '../DescriptionPanel/descriptionPanel';
import SpecificationPanel from '../SpecificationPanel/specificationPanel';
import DownloadsPanel from '../DownloadsPanel/downloadsPanel';

const Panel = (props) => {
  return (
    <Fragment>
      <div className="panel">
        <div className="panels">
          <DescriptionPanel
            activeToggle={props.activeToggle}
            description={props.product.description}
            images={_.isEmpty(props.product.image_urls) ? [] : props.product.image_urls}
          />
          <SpecificationPanel
            activeToggle={props.activeToggle}
            specification={props.product.specification}
          />
          <DownloadsPanel activeToggle={props.activeToggle} downloads={props.product.downloads} />
        </div>
      </div>
      <div className="control">
        <a
          onClick={(e) => {
            props.favouriteItem(e, props.product.hash_id);
          }}
          className="button button-green"
        >
          Add to favourites
        </a>
      </div>
    </Fragment>
  );
};

Panel.propTypes = {
  activeToggle: PropTypes.string.isRequired,
  product: PropTypes.shape({
    hash_id: PropTypes.string,
    description: PropTypes.string,
    image_urls: PropTypes.array,
    downloads: PropTypes.array,
  }).isRequired,
};

export default Panel;



// WEBPACK FOOTER //
// ./src/components/Panel/panel.js